import { formatNumberWithCommas } from '@/utils'
import { Flag, Stamp, Ship } from '@element-plus/icons-vue'
import { range } from 'lodash'

export const borderGameList = [
  {
    name: 'StopToEnd',
    icon: Flag,
    title: '一站到底',
    desc: '选择一块您的专属区域，站到最后赢取丰厚奖赏',
  },
  {
    name: 'CrazyGraffiti',
    icon: Stamp,
    title: '疯狂涂鸦',
    desc: '积极参与涂鸦，与另一支队伍角胜',
  },
  {
    name: 'FishingCompetition',
    icon: Ship,
    title: '钓鱼大赛',
    desc: '展示您的钓鱼技巧，与全服竞技',
  },
]

export type StopToEndInfoRes = {
  joinIndex?: number
  sectionList: number[]
  sectionUserRecord: Record<number, number>
  sectionRecordList: number[][]
}
export const stopToEndSectionList = [
  { name: '岗楼', color: '#e7e7eb' },
  { name: '村舍', color: '#F0E68C' },
  { name: '木屋', color: '#D2691E' },
  { name: '钟楼', color: '#5383c3' },
  { name: '花园', color: '#ADFF2F' },
  { name: '壁巢', color: '#DEB887' },
  { name: '狗窝', color: '#A0522D' },
  { name: '狼舍', color: '#483D8B' },
  { name: '鬼楼', color: '#2F4F4F' },
  { name: '邪庙', color: '#B22222' },
  { name: '暗穴', color: '#56564b' },
  { name: '幽宅', color: '#c0c6c9' },
  { name: '魔泉', color: '#00FFFF' },
  { name: '云殿', color: '#87CEEB' },
  { name: '龙崖', color: '#FFD700' },
  { name: '天城', color: '#ADD8E6' },
]
export const stopToEndSectionRoundMap: Record<number, number> = {
  16: 0,
  8: 1,
  4: 2,
  2: 3,
  1: 4,
}
export const stopToEndRoundGoldMeg: Record<number, number> = {
  1: 0.1,
  2: 0.2,
  3: 0.25,
  4: 0.45,
}
export function getStopToEndMsg(sectionRecordList: number[][], sectionUserRecord: Record<number, number>, playerCount: number, joinIndex?: number) {
  const totalGold = playerCount * 100000
  const res: string[] = []
  let initSectionList = range(0, 16)
  const fallPlayerCountList = sectionRecordList.map((item, index) => {
    return Object.entries(sectionUserRecord).reduce((pre, [key, value]) => {
      const _key = Number(key)
      if (item.includes(_key)) return pre
      return (pre += value)
    }, 0)
  })
  sectionRecordList.forEach((item, index) => {
    const fallSectionList = initSectionList.filter((section) => !item.includes(section))
    const fallPlayerCount = fallPlayerCountList[index] - (fallPlayerCountList[index - 1] || 0)
    const leftPlayerCount = playerCount - fallPlayerCountList[index]
    const gold = totalGold * stopToEndRoundGoldMeg[index + 1]
    const isSuc = item.includes(joinIndex || -1)
    const isFallPreRound = !(sectionRecordList[index - 1]?.includes(joinIndex || -1) ?? true)
    initSectionList = initSectionList.filter((section) => item.includes(section))
    res.push(
      `第<span class="info"> ${index + 1} </span>轮结束${
        typeof joinIndex === 'number' && !isFallPreRound
          ? `（您在本轮中${isSuc ? '<span class="grow">存活</span>' : '<span class="hp">坠落</span>'}）`
          : ''
      }<br />本轮中【${fallSectionList
        .map((section) => {
          const curSection = stopToEndSectionList[section]
          return `<span style="color: ${curSection.color}">${curSection.name}</span>`
        })
        .join('、')}】坠落<br />本次坠落人数：<span class="hp">${formatNumberWithCommas(
        fallPlayerCount,
      )}</span>，剩余人数：<span class="grow">${leftPlayerCount}</span><br />瓜分金币：<span class="gold">${formatNumberWithCommas(
        gold,
      )}</span>（人均：<span class="gold">${formatNumberWithCommas(Math.ceil(gold / leftPlayerCount))}</span>）`,
    )
  })
  return res
}

export type CrazyGraffitiInfoRes = {
  sectionList: number[]
  group?: number
  answer?: number[]
  drawTime: string
  winGroup: number
  isEnd: boolean
  playerCount: number
}
export const crazyGraffitiColorList = ['#FF6347', '#FFA500', '#FFFF99', '#32CD32', '#40E0D0', '#4169E1', '#9400D3']

export const fishingCopywriting = [
  '姜太公钓的是文王，我钓的是清凉。',
  '生活就像抛竿，沉住气，才有惊喜。',
  '水下通告：今日伙食已达标，拒签。',
  '水边一坐，谁也不爱。',
  '垂钓的尽头是喂鱼，喂鱼的尽头是开心。',
  '今日鱼获：空军一号。战绩稳定，发挥出色。',
  '我和鱼今天达成了共识：互不打扰。',
  '水边坐一天，烦恼全喂鱼。',
  '希望鱼儿能像我的钱包一样，偶尔也能鼓一次。',
]
export const fishList = [
  {
    id: 101,
    sizeRange: [3, 30],
    runTime: 1.5,
    targetDiameter: 120,
    name: '沙丁鱼',
    quality: 'normal',
  },
  {
    id: 102,
    sizeRange: [13, 41],
    runTime: 1.8,
    targetDiameter: 100,
    name: '太阳鱼',
    quality: 'normal',
  },
  {
    id: 103,
    sizeRange: [23, 51],
    runTime: 1.75,
    targetDiameter: 100,
    name: '鲷鱼',
    quality: 'normal',
  },
  {
    id: 104,
    sizeRange: [33, 61],
    runTime: 2,
    targetDiameter: 80,
    name: '鲤鱼',
    quality: 'normal',
  },
  {
    id: 201,
    sizeRange: [43, 71],
    runTime: 1.5,
    targetDiameter: 90,
    name: '金枪鱼',
    quality: 'race',
  },
  {
    id: 202,
    sizeRange: [53, 81],
    runTime: 1.4,
    targetDiameter: 100,
    name: '鳕鱼',
    quality: 'race',
  },
  {
    id: 203,
    sizeRange: [30, 114],
    runTime: 1,
    targetDiameter: 120,
    name: '章鱼',
    quality: 'race',
  },
  {
    id: 204,
    sizeRange: [53, 102],
    runTime: 1,
    targetDiameter: 90,
    name: '剑鱼',
    quality: 'race',
  },
  {
    id: 301,
    sizeRange: [83, 111],
    runTime: 0.8,
    targetDiameter: 70,
    name: '麻哈脂鲤',
    quality: 'epic',
  },
  {
    id: 302,
    sizeRange: [50, 153],
    runTime: 0.7,
    targetDiameter: 90,
    name: '冰柱鱼',
    quality: 'epic',
  },
  {
    id: 303,
    sizeRange: [83, 105],
    runTime: 1,
    targetDiameter: 60,
    name: '鬼鱼',
    quality: 'epic',
  },
  {
    id: 304,
    sizeRange: [80, 132],
    runTime: 0.6,
    targetDiameter: 100,
    name: '狮子鱼',
    quality: 'epic',
  },
  {
    id: 401,
    sizeRange: [80, 204],
    runTime: 0.5,
    targetDiameter: 60,
    name: '冰川鱼',
    quality: 'legend',
  },
  {
    id: 402,
    sizeRange: [153, 184],
    runTime: 0.38,
    targetDiameter: 80,
    name: '绯红鱼',
    quality: 'legend',
  },
  {
    id: 403,
    sizeRange: [130, 196],
    runTime: 0.45,
    targetDiameter: 70,
    name: '𩽾𩾌鱼',
    quality: 'legend',
  },
  {
    id: 404,
    sizeRange: [160, 190],
    runTime: 0.4,
    targetDiameter: 50,
    name: '传说之鱼',
    quality: 'legend',
  },
]
